import { createFileRoute } from "@tanstack/react-router"
import { Contact } from "@/content"

export const Route = createFileRoute("/(public)/contact")({
  component: RouteComponent,
})

function RouteComponent() {
  return <Contact />
}
